import { utilities } from '../../table/src';
var _a = utilities, filtering = _a.filtering, propertyFiltering = _a.propertyFiltering, pagination = _a.pagination, selection = _a.selection;
export default {
    filtering: filtering,
    propertyFiltering: propertyFiltering,
    pagination: pagination,
    selection: selection
};
//# sourceMappingURL=componentsUtilities.js.map